var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-item"},[_c('icon',{staticClass:"check-icon",attrs:{"name":"check-circle"}}),_c('span',{staticClass:"section-item-name"},[_vm._v(_vm._s(_vm.itemName)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }